// extracted by mini-css-extract-plugin
export default {"form":"AccountDeleteConfirmation_form__bFTqI","formButton":"AccountDeleteConfirmation_formButton__hbjMs"};